import { FC, ReactElement, ReactNode } from 'react';
import { Box, Flex, Text, FlexProps, Skeleton } from '@chakra-ui/react';
import { CbAvatar } from '../CbAvatar';
import { CbProfileInformationProps } from '../CbProfileInformation';
import GeoPin from '../Icons/GeoPin';
import BriefCase from '../Icons/BriefCase/BriefCase';
interface DecoratedSubTextProps {
  text: string;
  icon: ReactNode;
}
const DecoratedSubText: FC<DecoratedSubTextProps> = ({
  text,
  icon
}) => {
  return <Flex marginRight={4} marginBottom={1} alignItems="center" data-sentry-element="Flex" data-sentry-component="DecoratedSubText" data-sentry-source-file="CbPlayerStub.tsx">
      {icon}
      <Text fontSize="sm" color="text.tertiary" fontWeight="semibold" data-sentry-element="Text" data-sentry-source-file="CbPlayerStub.tsx">
        {text}
      </Text>
    </Flex>;
};
export interface UserDisplay {
  description?: string;
  id: string;
  name: string;
  badgeUrl?: string;
  image?: string;
  jobTitle?: string;
  location?: string;
}
export interface CbPlayerStubProps extends Partial<CbProfileInformationProps>, Partial<FlexProps> {
  avatarSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'custom';
  user: UserDisplay;
  titleAdornment?: ReactElement;
  isLoading?: boolean;
}
export const CbPlayerStub: FC<CbPlayerStubProps> = ({
  user,
  avatarSize,
  titleAdornment,
  isLoading,
  ...props
}) => {
  if (isLoading) {
    return <Skeleton backgroundColor="cloud.400" borderRadius={10} height={16} />;
  }
  return <Flex width="100%" alignItems="center" {...props} data-sentry-element="Flex" data-sentry-component="CbPlayerStub" data-sentry-source-file="CbPlayerStub.tsx">
      <CbAvatar avatarSize={avatarSize || 'lg'} image={user?.image} name={user?.name} badgeUrl={user?.badgeUrl} data-sentry-element="CbAvatar" data-sentry-source-file="CbPlayerStub.tsx" />
      <Box marginLeft={4} width="100%" data-sentry-element="Box" data-sentry-source-file="CbPlayerStub.tsx">
        <Flex alignItems="center" data-sentry-element="Flex" data-sentry-source-file="CbPlayerStub.tsx">
          <Text fontFamily="codenext" fontWeight="bold" fontSize="md" color="text.primary" marginRight={2} data-sentry-element="Text" data-sentry-source-file="CbPlayerStub.tsx">
            {user?.name}
          </Text>
          {titleAdornment}
        </Flex>
        <Flex marginY={1} data-sentry-element="Flex" data-sentry-source-file="CbPlayerStub.tsx">
          {user?.jobTitle && <DecoratedSubText icon={<BriefCase marginRight={1} color="text.tertiary" />} text={user?.jobTitle || ''} />}
          {user?.location && <DecoratedSubText icon={<GeoPin marginRight={1} color="text.tertiary" />} text={user?.location || ''} />}
        </Flex>
      </Box>
    </Flex>;
};